import React from 'react';
import { ButtonSC, PrefixSC, SuffixSC } from './button.styled';
import Spinner from '@common/assets/svg/icon-loading_spinner-white.svg';

export type TPropsSC = {
  size?: 'small' | 'medium' | 'large';
  variation?: 'primary' | 'secondary' | 'warn' | 'link';
  shape?: 'round' | 'rectangular';
  isLoading?: boolean;
  isBlock?: boolean;
  suffix?: React.ReactNode;
  prefix?: React.ReactNode;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

const Button: React.FC<TPropsSC> = ({
  children,
  shape = 'rectangular',
  isLoading,
  suffix,
  prefix,
  ...props
}) => {
  return (
    <ButtonSC {...props}>
      {prefix && <PrefixSC>{prefix}</PrefixSC>}
      {isLoading ? <img src={Spinner} alt="loading-spinner" /> : null}
      {children}
      {suffix && <SuffixSC>{suffix}</SuffixSC>}
    </ButtonSC>
  );
};

Button.defaultProps = {
  size: 'medium',
};

export default Button;
